import { IEntity } from '../../../libraries/entity';
import { ILoginResponse } from '../../../libraries/login';
import { IUser } from '../../../libraries/user';
import { UserPermissionsHandler } from '../../utils/user-permissions';
import { AppAction } from '../actions';
import { ActionTypes } from './actionTypes';

export interface SessionSettings {
  useDashboardEntity?: boolean;
  useReasonsAndDeclarations?: boolean;
  useShifts?: boolean;
  usePos?: boolean;
  useProducts?: boolean;
  useDispensers?: boolean;
  useEventDistributionList?: boolean;
  useCashCollections?: boolean;
  useWithdrawalSet?: boolean;
  useUserBalance?: boolean;
}

export interface LoginState {
  loading?: boolean;
  user: IUser;
  entity?: IEntity;
  loginSuccess: boolean;
  token?: string;
  equipmentTypes?: number[];
  permissions: UserPermissionsHandler;
  settings: SessionSettings;
}

const initialState: LoginState = {
  user: { entid: 0, uid: 0, lang: 0 },
  loginSuccess: false,
  permissions: new UserPermissionsHandler([]),
  settings: {}
};

export const createSessionSettings = (login?: ILoginResponse): SessionSettings => {
  console.log('login:', login);
  const settings: SessionSettings = {};

  //Dev pages are not fully ready for production
  let devPagesEnabled = process.env.REACT_APP_DEV_PAGES_ENABLED === 'true' ? true : false;
  if (devPagesEnabled) {
    settings.useDashboardEntity = true;
  }

  const hasBankDepositEquipments = login?.equipmentTypes?.find(elem => elem === 412 || elem === 442);
  if (hasBankDepositEquipments) {
    settings.useReasonsAndDeclarations = true;
  }

  settings.useShifts = login?.entity?.useShifts === 1;
  settings.usePos = login?.entity?.usePos === 1;
  if (process.env.REACT_APP_USE_PRODUCTS_AND_DISPENSERS === 'true') {
    settings.useProducts = true;
    settings.useDispensers = true;
  }

  //TODO: improve useCashCollections, few equipments have EMPTY_SAFE transactions
  settings.useCashCollections = login?.entity?.entid === 9999 || login?.entity?.entid === 801;

  let isBrisa = login?.entity?.entid === 9999 || login?.entity?.entid === 400;
  settings.useEventDistributionList = isBrisa;
  settings.useWithdrawalSet = isBrisa;
  settings.useUserBalance = isBrisa;

  console.log('settings', settings);
  return settings;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: AppAction<any>): LoginState => {
  switch (action.type) {
    case ActionTypes.LOGGING_IN: {
      return {
        ...state,
        loginSuccess: false,
        loading: true
      };
    }
    case ActionTypes.LOGGED_IN: {
      return {
        ...state,
        ...action.payload,
        permissions: new UserPermissionsHandler(action.payload?.user?.permissions || []),
        settings: createSessionSettings(action.payload),
        loginSuccess: true
      };
    }
    case ActionTypes.LOGGED_ERROR: {
      return { ...state, loginSuccess: false, loading: false };
    }
    case ActionTypes.LOGOUT: {
      return {
        ...initialState,
        loginSuccess: false
      };
    }
    default:
      return state;
  }
};
